import { html } from "lit";
var icon_flag_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M6 5a3 3 0 013-3h4.764c.466 0 .925.108 1.342.317L18.473 4H23a3 3 0 012.995 2.824L26 7v10a3 3 0 01-3 3h-4.764c-.466 0-.925-.108-1.342-.317L13.528 18H9c-.35 0-.687-.06-1-.17V29H6zm7.764-1H9a1 1 0 00-1 1v10a1 1 0 001 1h4.764c.155 0 .308.036.447.106l3.578 1.788c.139.07.292.106.447.106H23a1 1 0 001-1V7a1 1 0 00-1-1h-4.764a.993.993 0 01-.447-.106L14.21 4.106A.993.993 0 0013.763 4z" />
  </svg>
`;
export {
  icon_flag_default as default
};
//# sourceMappingURL=icon-flag.js.map
